import { emailSchema, gstNumberSchema, phoneNumberSchema } from "utils/schemas";
import * as Yup from "yup";

const schema = Yup.object({
  name: Yup.string()
    .trim()
    .min(1)
    .max(255)
    .matches(
      /^[a-zA-Z0-9 &()]+$/,
      "Name can only contain letters, numbers, spaces, &, ( and )",
    )
    .required("Name is required"),
  email: emailSchema.optional(),
  phone: phoneNumberSchema.nullable().optional(),
  address: Yup.string().max(4000).nullable().optional(),
  city: Yup.string().max(128).nullable().optional(),
  state: Yup.string().max(128).nullable().optional(),
  gstNumber: gstNumberSchema.nullable().optional(),
  isActive: Yup.boolean(),
});

export default schema;
